import script from "./baseMessage.vue?vue&type=script&setup=true&lang=ts"
export * from "./baseMessage.vue?vue&type=script&setup=true&lang=ts"

import "./baseMessage.vue?vue&type=style&index=0&id=4eda5f62&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.3.13_webpack@5.99.5/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4eda5f62"]])

export default __exports__